import { createContext, useCallback, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useLocalStorage } from '../ThemeContext/useLocalStorage';

export const FINANCIAL_PRIVACY_STORAGE_KEY = 'showValues';

const FinancialPrivacyContext = createContext({
  valuesVisible: true,
  toggleValuesVisibility: () => {},
});

export const FinancialPrivacyProvider = ({ children }) => {
  const [valuesVisible, setValuesVisible] = useLocalStorage(
    FINANCIAL_PRIVACY_STORAGE_KEY,
    false
  );
  const toggleValuesVisibility = useCallback(() => {
    setValuesVisible((visible) => !visible);
  }, [setValuesVisible]);
  const value = useMemo(() => ({ valuesVisible, toggleValuesVisibility }), [toggleValuesVisibility, valuesVisible]);

  return (
    <FinancialPrivacyContext.Provider value={value}>
      {children}
    </FinancialPrivacyContext.Provider>
  );
};

FinancialPrivacyProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useFinancialPrivacy = () => useContext(FinancialPrivacyContext);

